import {ButtonFlat, MainTitle} from 'ui';
import {Container, SmallTitleWhite} from './styles';
import {withRouter} from 'react-router';

import bgFormations from 'assets/img/homepageFormations.png';

const HomepageFormations = () => (
  <Container style={{backgroundImage: `url(${bgFormations})`}}>
    <MainTitle style={{maxWidth: 330, marginTop: 'auto'}}>Avec l’Académie Maison Carte d’Or</MainTitle>
    <SmallTitleWhite>FORMATIONS</SmallTitleWhite>
    <ButtonFlat style={{margin: '0 auto'}} to="/formations">
      Voir les formations
    </ButtonFlat>
  </Container>
);

export default HomepageFormations |> withRouter;
